import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CrossRegular from 'jl-ui-kit/elements/icons/CrossRegular';

import styles from './notification-banner.scss';

const cookieNameRegex = /^([A-Za-z0-9!#$%&'()*+-./:<=>?@[\]^_`{|}~]+)$/;

const checkValidCookieName = dismiss => {
  if (!cookieNameRegex.test(dismiss)) {
    if (process.env.NODE_ENV !== 'test') {
      // eslint-disable-next-line no-console
      console.error(
        "Invalid notification banner cookie name, allowed characters are alpha numeric and !#$%&'()*+-./:<=>?@[]^_`{|}~"
      );
    }
    return false;
  }
  return true;
};

const NotificationBanner = ({
  className,
  style,
  content,
  cta,
  url,
  hide,
  dismiss,
  closeHandler,
}) => (
  <div
    className={classNames(
      className,
      styles.banner,
      styles[`banner--${style}`],
      {
        [styles.hide]: hide,
      }
    )}
  >
    <div className={styles.wrapper}>
      <span className={styles.content}>
        {`${content} `}
        {url !== '' ? <a href={url}>{cta}</a> : cta}
      </span>
      {!!dismiss && checkValidCookieName(dismiss) && (
        <button className={styles.banner__button} onClick={closeHandler}>
          <CrossRegular />
        </button>
      )}
    </div>
  </div>
);

NotificationBanner.defaultProps = {
  style: 'notice',
  cta: '',
  url: '',
  hide: false,
  closeHandler: () => {},
};

NotificationBanner.propTypes = {
  content: PropTypes.string.isRequired,
  style: PropTypes.oneOf(['notice']),
  cta: PropTypes.string,
  url: PropTypes.string,
  hide: PropTypes.bool,
  closeHandler: PropTypes.func,
};

export default NotificationBanner;
